// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__uIixX","container":"Registration_container__m0ac8"};